export function UserIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M10,9.86A3.87,3.87,0,1,0,6.13,6,3.87,3.87,0,0,0,10,9.86Zm0-6A2.19,2.19,0,1,1,7.81,6,2.19,2.19,0,0,1,10,3.81Z" />
      <path d="M10,10.62a6.42,6.42,0,0,0-6.26,5A6.72,6.72,0,0,0,3.58,17a.84.84,0,0,0,1.68,0A4.63,4.63,0,0,1,5.38,16,4.72,4.72,0,0,1,7,13.35a4.66,4.66,0,0,1,3-1,4.75,4.75,0,0,1,4.64,3.78,5,5,0,0,1,.1,1,.84.84,0,0,0,1.68,0,7,7,0,0,0-.13-1.29A6.44,6.44,0,0,0,10,10.62Z" />
    </svg>
  )
}
